/**
 * useViewTracker — fire-and-forget POST /api/views/track when a page/product mounts.
 *
 * Features:
 *  • Deduped per session (sessionStorage) so refresh doesn't inflate the count.
 *  • Silent failure (analytics must never break the UX).
 *  • Skips when entityId is falsy (e.g. detail page still loading).
 *
 * Usage:
 *      useViewTracker("page", location.pathname);
 *      useViewTracker("cab", cab?.id);
 *      useViewTracker("destination", d?.slug);
 */
import { useEffect } from "react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const useViewTracker = (entityType, entityId) => {
    useEffect(() => {
        if (!entityType || !entityId) return;
        const key = `vt:${entityType}:${entityId}`;
        try {
            if (sessionStorage.getItem(key)) return;
            sessionStorage.setItem(key, "1");
        } catch {
            /* ignore quota / private-mode errors */
        }
        axios
            .post(`${API_BASE}/views/track`, { entityType, entityId })
            .catch(() => {
                /* silent failure */
            });
    }, [entityType, entityId]);
};

export default useViewTracker;
